import { render, staticRenderFns } from "./addorupdatecate.vue?vue&type=template&id=ea0e6500"
import script from "./addorupdatecate.vue?vue&type=script&lang=js"
export * from "./addorupdatecate.vue?vue&type=script&lang=js"
import style0 from "./addorupdatecate.vue?vue&type=style&index=0&id=ea0e6500&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports